import { render } from "./Agile.vue?vue&type=template&id=038e0e82&ts=true"
import script from "./Agile.vue?vue&type=script&lang=ts"
export * from "./Agile.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__